// components/HoursInput.jsx
import React from 'react';

export const HoursInput = ({ 
  disabled, 
  from, 
  to, 
  onFromChange, 
  onToChange 
}) => {
  return (
    <div className="d-flex gap-3 align-items-center flex-wrap">
      <div className="d-flex align-items-center gap-2">
        <span className="text-nowrap">початок:</span>
        <input
          type="text"
          className="form-control form-control-sm"
          style={{ width: '80px' }}
          disabled={disabled}
          value={from || ''}
          onChange={(e) => onFromChange(e.target.value)}
          placeholder="9-00"
        />
      </div>
      <div className="d-flex align-items-center gap-2">
        <span className="text-nowrap">закінчення:</span>
        <input
          type="text"
          className="form-control form-control-sm"
          style={{ width: '80px' }}
          disabled={disabled}
          value={to || ''}
          onChange={(e) => onToChange(e.target.value)}
          placeholder="19-00"
        />
      </div>
    </div>
  );
};